import { z } from "zod";

import { fetchJSON } from "@/src/requests/utils/fetch-json";

const locationProvidersInstructionsEntrySchema = z.object({
  receivingLocationId: z.string().min(1),
  providers: z.array(z.string()),
  department: z
    .object({
      id: z.string(),
      name: z.string(),
      providerGroup: z.string().optional(),
    })
    .nullable(),
});

export const locationProvidersInstructionsResultSchema = z.array(locationProvidersInstructionsEntrySchema);

export type LocationProvidersInstructionsEntry = z.infer<typeof locationProvidersInstructionsEntrySchema>;
export type LocationProvidersInstructionsResult = z.infer<typeof locationProvidersInstructionsResultSchema>;

export async function getLocationProvidersInstructions(
  locationId: string | null
): Promise<LocationProvidersInstructionsResult> {
  const data = await fetchJSON<LocationProvidersInstructionsResult>("/api/location-providers-instructions", {
    method: "POST",
    body: JSON.stringify({ locationId }),
  });

  return locationProvidersInstructionsResultSchema.parse(data);
}
